const cloneDeep = require('lodash.clonedeep')
/**
 * 
 * @param {Initial Object} init 
 * @param {Object being used} state 
 */
function Formalize(init, state) {
  let clonedInit = cloneDeep(init);

  Object.keys(state).forEach(key => {
    if(clonedInit[key]) {
      if(state[key] !== undefined && state[key] !== null) {
        clonedInit[key].value = state[key];
      }
      /** Save the current value incase it needs to be used elsewhere */
      clonedInit[`curr_${key}`] = state[key]
    }
    else {
      /** Still save the key on the object */
      clonedInit[key] = state[key]
    }
  })
  
  return clonedInit;
}

module.exports = Formalize
exports.default = Formalize